import axios from "axios";
import { v4 } from "uuid";

export const getRedditIntegrationUrl = async (accessToken: string): Promise<string> => {
    const response = await axios.get(process.env.REACT_APP_API_URL + '/v1/users/integrations/reddit', {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });
    
    if (response.status !== 200) {
        throw new Error('Failed to get reddit sign in url');
    }
    
    return response.data.url as string;
};

export const disconnectRedditIntegration = async (accessToken: string): Promise<void> => {
    const response = await axios.delete(process.env.REACT_APP_API_URL + '/v1/users/integrations/reddit', {
        headers: {
            'Authorization': accessToken,
            'X-Request-ID': v4()
        }
    });
    
    if (response.status !== 204) {
        throw new Error('Failed to disconnect reddit integration');
    }
};